import { experience } from "../lib/profile";

/** Each role carries its own colour down the rail. */
const roleColors = [
  "var(--c-industry)",
  "var(--c-personal)",
  "var(--c-leading)",
  "var(--c-university)",
];

export function Experience() {
  return (
    <section className="exp" id="experience">
      <div className="exp__head" data-reveal>
        <span className="eyebrow">Experience</span>
        <h2>
          Where I&rsquo;ve <span className="hl hl--blue">worked</span>
          <br />
          and learned.
        </h2>
      </div>

      <ol className="exp__list">
        {experience.map((role, i) => (
          <li
            className="exp__row"
            key={`${role.company}-${role.period}`}
            data-reveal
            style={
              {
                "--chip": roleColors[i % roleColors.length],
              } as React.CSSProperties
            }
          >
            <div className="exp__rail" aria-hidden="true">
              <span className="exp__dot" />
            </div>
            <div className="exp__when">
              <span className="exp__period">{role.period}</span>
              <span className="exp__no">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <div className="exp__body">
              <h3 className="exp__company">{role.company}</h3>
              {role.positions.length === 1 ? (
                <>
                  <p className="exp__title">{role.positions[0].title}</p>
                  <p className="exp__summary">{role.positions[0].summary}</p>
                </>
              ) : (
                <ol className="exp__roles">
                  {role.positions.map((position) => (
                    <li className="exp__role" key={position.title}>
                      <div className="exp__role-head">
                        <span className="exp__role-title">
                          {position.title}
                        </span>
                        <span className="exp__role-period">
                          {position.period}
                        </span>
                      </div>
                      <p className="exp__role-summary">{position.summary}</p>
                    </li>
                  ))}
                </ol>
              )}
              <div className="exp__stack">
                {role.stack.map((tech) => (
                  <span key={tech}>{tech}</span>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
